import { Icon, IconNames } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import {
  ConversationDirection,
  ConversationsChannels,
  ConversationStatus,
} from 'lib-shared-legacy-types';
import { PureComponent } from 'react';
import { Dictionary } from 'ts-essentials';

import { ContactIsTypingIndicator } from './components/ContactIsTypingIndicator';
import { DirectionIcon } from './components/DirectionIcon';
import {
  CONVERSATION_DIRECTION_INBOUND,
  CONVERSATION_STATUS_ACTIVE,
  CONVERSATION_STATUS_AWAITING_PENDING,
  CONVERSATION_STATUS_NONE,
  CONVERSATION_STATUS_PENDING,
} from './constants';
import styles from './styles.module.scss';

type PropsT = {
  className?: string;
  channel?: ConversationsChannels | null;
  /** Conversation direction */
  direction?: ConversationDirection;
  /** Status */
  status?: ConversationStatus | null;
  /** Loading */
  loading?: boolean;
  /** Large */
  large?: boolean;
  /** Is contact currently typing? */
  typing?: boolean;
  /** Unread message count */
  unreadCount?: number;
};

const ICON_MAPPING: Dictionary<IconNames, ConversationsChannels> = {
  adachat: 'messenger',
  digitalgeniuschat: 'messenger',
  kindlychat: 'messenger',
  pstnphone: 'phone',
  email: 'mail',
  widgetchat: 'chat',
  messenger: 'messenger',
  facebookmessenger: 'facebook-messenger',
  whatsapp: 'whatsapp',
  sms: 'sms',
  callback: 'phone-plus',
  voicemail: 'voicemail',
  contactform: 'chat-widget',
  twitter: 'twitter',
};

export class ConversationStatusIcon extends PureComponent<PropsT> {
  static defaultProps = {
    direction: CONVERSATION_DIRECTION_INBOUND,
    status: CONVERSATION_STATUS_NONE,
  };

  render() {
    const {
      className,
      channel,
      direction,
      status,
      loading,
      typing,
      unreadCount,
      large,
      ...otherProps
    } = this.props;

    const rootClass = this.getRootClassName(status, loading, large, className);

    return (
      <div {...otherProps} className={rootClass}>
        {typing ? (
          <ContactIsTypingIndicator />
        ) : (
          <Icon className={styles.icon} name={ICON_MAPPING[channel ?? 'sms']} />
        )}

        <DirectionIcon
          direction={direction}
          size={this.getDirectionIconSize(large)}
        />
      </div>
    );
  }

  private getRootClassName(
    status?: string | null,
    loading?: boolean,
    large?: boolean,
    className?: string,
  ) {
    return classnames(
      {
        [styles.root]: true,
        [styles.rootActive]: status === CONVERSATION_STATUS_ACTIVE,
        [styles.rootFollowUp]: this.hasFollowup(status),
        [styles.rootLoading]: loading,
        [styles.rootLarge]: large,
      },
      className,
    );
  }

  private getDirectionIconSize(large?: boolean) {
    return large ? '21' : '13';
  }

  private hasFollowup(status?: string | null) {
    return (
      status === CONVERSATION_STATUS_PENDING ||
      status === CONVERSATION_STATUS_AWAITING_PENDING
    );
  }
}
